<div class="h-10 flex flex-row gap-0.5 items-center w-fit" @breadcrumbsAnimation>
    <ng-container *ngFor="let route of routes; let i = index">
        <a *ngIf="i == 0" class="flex flex-row gap-0.5 items-center btn" [routerLink]="route.url">
            <div class="w-5 h-5 flex justify-center items-center text-exp text-xs" *ngIf="showBackIcon">
                <i class="fa-regular" [ngClass]="(language | language)?'fa-angle-right':'fa-angle-left'"></i>
            </div>
            <p class="text-xs text-exp" [innerHTML]="route.name"></p>
        </a>
        <ng-container *ngIf="i > 0">
            <div class="w-5 h-5 flex justify-center items-center text-zen-primaryLight">
                <p>/</p>
            </div>
            <a [routerLink]="route.url" routerLinkActive #rla="routerLinkActive" class="text-xs"
                [ngClass]="rla.isActive?'text-zen pointer-events-none':'text-exp btn'"
                [routerLinkActiveOptions]="{ exact: true }" [innerHTML]="route.name">
            </a>
        </ng-container>
    </ng-container>
</div>